import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-location-routes',
  templateUrl: './location-routes.component.html',
  styleUrls: ['./location-routes.component.scss']
})
export class LocationRoutesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
